"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.warn = exports.errorPos = exports.withErrorConsole = void 0;
const chalk_1 = __importDefault(require("chalk"));
function withErrorConsole(fn) {
    return function (...args) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield fn(...args);
            }
            catch (error) {
                if (error instanceof Error) {
                    error = error.message.replace(/^Error: /, '');
                }
                console.log(`error: ${error}`);
            }
        });
    };
}
exports.withErrorConsole = withErrorConsole;
function errorPos(str, errorStr, subStr) {
    let baseIndex = 0;
    let searchStr = str;
    if (subStr) {
        baseIndex = str.indexOf(subStr);
        searchStr = subStr;
    }
    const position = searchStr.indexOf(errorStr) + baseIndex;
    const errorStrLen = errorStr.length;
    const mark = `${chalk_1.default.bgYellow('|')} `;
    str = str.slice(0, position) + chalk_1.default.bgYellow.red(errorStr) + str.slice(position + errorStrLen);
    return `${mark}${str}\n${mark}${' '.repeat(position)}${chalk_1.default.yellow('^')}`;
}
exports.errorPos = errorPos;
function warn(info) {
    console.log(`warn: ${info}`);
}
exports.warn = warn;
